module.exports = __webpack_public_path__ + "media/images/payment-2-58c01a3b34cb9506cfb14f3df95dd400.png";